module.exports = __webpack_public_path__ + "static/OneDotExt-BoldItalic.b524c6ae.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-BoldItalic.woff
// module id = 751
// module chunks = 114276838955818